import { Box, Container } from '@chakra-ui/react';
import SettingsSidebarContainer from 'presentation/containers/modules/settings/SettingsSidebarContainer';
import PageLayout from 'presentation/layout/shared/page/PageLayout';
import { FC, PropsWithChildren } from 'react';

const SettingsLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <PageLayout>
      <Container display="flex" alignItems="flex-start">
        <SettingsSidebarContainer />
        <Box flex="1">{children}</Box>
      </Container>
    </PageLayout>
  );
};

export default SettingsLayout;
